package org.teddapp.project.portfolio.export

/**
 * Capacités d'export fournies par la plateforme, à la manière de `ParcoursFilePicker` :
 * une lambda nulle veut dire « pas disponible ici ». Le bureau installe les deux au
 * démarrage ; sur téléphone, l'interface copie le Markdown dans le presse-papiers et
 * ne propose pas le PDF.
 *
 * Chaque lambda renvoie le chemin écrit, ou null si l'utilisateur a annulé.
 */
object PortfolioExporters {
    var savePdf: (suspend (suggestedName: String, doc: PortfolioDoc) -> String?)? = null
    var saveMarkdown: (suspend (suggestedName: String, text: String) -> String?)? = null
}
